import { Product } from '@core/models/piramide/Product';

export class Fuente extends Product {
  $caracteristicas: {
    ModoHibrido: number;
    amper12v: number;
    certi80plus: string;
    color: string;
    compatible_abajo: number;
    digital: number;
    disponible: number;
    floppy: null;
    id_producto: number;
    iluminacion: null;
    incluye_cable: number;
    kit: number;
    marca: null;
    molex: string;
    pines_pcie: number;
    pines_pcieplus: number;
    sata: number;
    tipo: string;
    tipocableado: string;
    w_nominal: number;
    w_real: number;
    _4pines: number;
    _4plus: number;
    _24pines: number;
    pcie_16pines: number;
  };
  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 34) {
      throw 'esto no es una fuente';
    }
  }
}
